import { render } from "./SerialTrackingDatas.vue?vue&type=template&id=499f36c0&scoped=true"
import script from "./SerialTrackingDatas.vue?vue&type=script&lang=ts"
export * from "./SerialTrackingDatas.vue?vue&type=script&lang=ts"

import "./SerialTrackingDatas.vue?vue&type=style&index=0&id=499f36c0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-499f36c0"

export default script